import vlTextLogo from "assets/img/visual-layer-text-logo.svg";
import vlLogo from "assets/img/vllogo.svg";
import { Outlet } from "react-router";
import { useState } from "react";

import styles from "./style.module.scss";

const LoginLayout = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoError, setVideoError] = useState(false);

  return (
    <div className={styles.mainContent}>
      <div className={styles.leftSection}>
        <div className={styles.upperLeftSection}>
          <div className={styles.logoContainer}>
            <img
              src={vlLogo}
              className={styles.imgLogo}
              alt="visual-layer-img-logo"
            />
            <img
              src={vlTextLogo}
              className={styles.textLogo}
              alt="visual-layer-text-logo"
            />
          </div>

          <Outlet />
        </div>
        {/* Trusted Section */}
        <div className={styles.trustedSection}>
          <span className={styles.trustedByTitle}>Trusted By</span>
          <div className={styles.trustedLogos}>
            <div className={styles.amazonLogo}></div>
            <div className={styles.microsoftLogo}></div>
            <div className={styles.appleLogo}></div>
            <div className={styles.walmartLogo}></div>
          </div>
        </div>
      </div>

      <div className={styles.rightSection}>
        {(videoError || !videoLoaded) && (
          // Show the placeholder image if there's an error or the video isn't ready yet
          <img
            alt="cover-img"
            src={"https://d1join20nb2yft.cloudfront.net/Signup_Cover.png"}
            className={styles.fallbackImage}
          />
        )}
        <video
          loop
          muted
          autoPlay
          className={styles.videoContainer}
          onError={() => setVideoError(true)}
          onCanPlay={() => setVideoLoaded(true)}
        >
          <source
            src={"https://d1join20nb2yft.cloudfront.net/video_signup.mp4"}
          />
        </video>
      </div>
    </div>
  );
};

export default LoginLayout;
